import { render, staticRenderFns } from "./ChannelList.pug?vue&type=template&id=688764a4&scoped=true&lang=pug&"
import script from "./ChannelList.vue?vue&type=script&lang=js&"
export * from "./ChannelList.vue?vue&type=script&lang=js&"
import style0 from "./ChannelList.scss?vue&type=style&index=0&id=688764a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688764a4",
  null
  
)

export default component.exports